import { render, staticRenderFns } from "./DriversShifts.vue?vue&type=template&id=6ec2693a&scoped=true&"
import script from "./DriversShifts.vue?vue&type=script&lang=js&"
export * from "./DriversShifts.vue?vue&type=script&lang=js&"
import style0 from "./DriversShifts.vue?vue&type=style&index=0&id=6ec2693a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec2693a",
  null
  
)

export default component.exports